export default __webpack_public_path__ + "static/media/calendar_bg.598a7482.png";